import Phonet from 'phonet-sdk'

export default Phonet({
  domain: process.env.REACT_APP_PHONET_DOMAIN,               
  apiKey: process.env.REACT_APP_PHONET_API_KEY
})


// WEBPACK FOOTER //
// ./src/services/phonet.js